export default __webpack_public_path__ + "static/media/calendar-icon.209b7a38.svg";